<template>
  <div class="board" ref="board">
    <main-menu></main-menu>

    <div class="main">
      <template v-if="showSubMenu">
        <sub-menu class="main-left"></sub-menu>
      </template>

      <div
        class="content main-right"
        :class="{ activeContent: isCollapse }"
        id="content"
        ref="content"
      >
        <bosk-tab-navigation v-show="showTabNavigation"></bosk-tab-navigation>
        <transition name="fade">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>

    <!-- <Footercus class="footer"></Footercus> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import MainMenu from "../page/commons/menu/mainMenu/mainMenu";
import SubMenu from "../page/commons/menu/subMenu/subMenu";
import Bread from "./commons/bread.vue";
import Footercus from "./commons/footer.vue";
import $ from "jquery";
import websocket from "../helper/websocket";
import { Notification } from "element-ui";
import BoskTabNavigation from "../page/commons/BoskTabNavigation/BoskTabNavigation.vue";
import { BLACK_ROUTE_PATH } from "../page/commons/BoskTabNavigation/constant";
export default {
  name: "maincus",
  data: function() {
    return {
      showSubMenu: false,
      fade: "fade",
      currentPath: "",
      blackRoutePath: [],
    };
  },
  components: {
    // Headercus,
    // Sidecus,
    Bread,
    Footercus,
    MainMenu,
    SubMenu,
    BoskTabNavigation,
  },
  created() {
    this.blackRoutePath = [...BLACK_ROUTE_PATH];
   
    document.getElementById("appLoading").style.display = "none";
    websocket.websocketListener((msg) => {
   
      const pathHash = window.location.hash;
      if (pathHash === "#/main/home") {
        this.setArrearsList({ ...msg });
      } else {
        if (msg.type === "arrearPlate") {
          Notification({
            type: "info",
            title: msg.plate,
            message: msg.message,
            position: "bottom-right",
            duration: 0,
          });
        }
        //  if(msg.type==='webPay'){
        //   Notification({
        //     type: "info",
        //     title: msg.message==='success'?'续费成功':'续费失败',
        //     message: msg.message==='success'?`金额：${msg.money}`:'',
        //     position: "top-right",
        //     duration: 0,
        //   });
        //  }
      }
    });
  },
  mounted() {

    this.getAdminData();
    const r = this.$route.path;
    this.$nextTick(function() {
      if (r === "/main/home") {
        this.showSubMenu = false;
        this.$refs.content.classList.remove("main-right");
      } else {
        this.showSubMenu = true;
        this.$refs.content.classList.add("main-right");
      }
    });
  },
  
  computed: {
    ...mapGetters("tabNavigation", ["currentNavigationList"]),
    ...mapState({
      isCollapse: (state) => state.menu.isCollapse,
      mainMenuHref: (state) => state.menu.mainMenuHref,
      showTabNavigation: (state) => {
        return state.tabNavigation.showTabNavigation;
      },
    }),
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.path === "/main/home") {
          this.showSubMenu = false;
          this.$refs.content.classList.remove("main-right");
        } else {
          this.showSubMenu = true;
          this.$refs.content.classList.add("main-right");
        }
      },
      deep: true,
      immidiate: true,
    },
    showTabNavigation: {
      handler(newVal, val) {
        console.log("show tab navigation=>", newVal);
      },
      immidiate: true,
    },
  },
  methods: {
    ...mapActions(["getAdminData"]),
    ...mapActions("arrearsInformation", ["setArrearsList"]),
    
  },
};
</script>
<style scoped>
.board {
  min-width: 1440px;
  margin: 0 auto;
  height: 100%;
}

.headercus {
  width: 100%;
  /* height: 50px; */
  /* box-shadow: 0px 10px 20px #777; */
}
.footer {
  width: 100%;
  /* background:#f9f9fb;  */
  background: #ebeef5;
}
.main {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  /* margin-top:10px; */
  position: relative;
  height: calc(100% - 70px);
}
.main .main-right {
  width: calc(100% - 258px);
  /* background:#eff2f7; */
  /* z-index: 10000; */
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  /* border-radius: 5px; */
}

/* 首页特殊处理 - 正常宽度时主内容区域禁止横向滚动 */
.main .main-right:has(.overview) {
  overflow-x: hidden !important;
}

/* 首页在小屏幕时允许横向滚动（用于操作导航栏） */
@media (max-width: 1280px) {
  .main .main-right:has(.overview) {
    overflow-x: auto !important;
  }
}

/* 其他页面在小屏幕时允许横向滚动 */
@media (max-width: 1280px) {
  .main .main-right:not(:has(.overview)) {
    overflow-x: auto !important;
  }
}
.main .content {
  width: 100%;
  padding-top: 0;
}

.main .activeContent {
  left: 64px;
  transition: all 0.3s ease;
}

.main-left {
  /* width: 15%; */
  width: 258px;
  /* background: #191c23; */
  overflow: hidden;
  overflow-y: auto;
}
.main-left::-webkit-scrollbar {
  display: none;
}
.tablelist {
  height: 100%;
  background: white;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}</style
>./commons/BoskTabNavigation/BoskTabNavigation.vue./commons/BoskTabNavigation/BoskTabNavigation.vue
